import React, { useState } from "react";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import { Card, Paper, Popover } from "@material-ui/core";
import clsx from "clsx";
import PopoverComponent from "./PopoverComponent";

const Warnings = () => {
  const classes = useStyles();
  const [state, setState] = useState({
    open: false,
    anchorEl: false,
  });

  const handleOpen = (event) => {
    setState((prevState) => ({
      ...prevState,
      open: true,
      anchorEl: event.target,
    }));
  };

  const handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      open: null,
      anchorEl: null,
    }));
  };

  return (
    <>
      <Card elevation={0} className={classes.card}>
        <span
          onClick={handleOpen}
          className={clsx(
            state.open ? "icon-x" : "icon-settings",
            classes.icon
          )}
        />
      </Card>
      {state.open && (
        <Popover
          open={state.open}
          anchorEl={state.anchorEl}
          onClose={handleClose}
          className={classes.popOverContainer}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <Paper
            className={clsx(classes.popOver, classes.popOver)}
            elevation={0}
          >
            <PopoverComponent />
          </Paper>
        </Popover>
      )}
    </>
  );
};

export default Warnings;
